import React, { useMemo } from 'react';
import {
	Col,
	Empty,
} from 'antd';
import { LaytimeTerms } from '@shared/utils/constants';
import type { GetCargosAndLaytimesResponse } from '@api/features/laytime/getCargosAndLaytimes';
import NonReversibleStats from './components/NonReversibleStats';
import ReversibleStats from './components/ReversibleStats';
import AveragedStats from './components/AveragedStats';

type Props = {
	selectedCargo: GetCargosAndLaytimesResponse['cargosAndLaytimes'][number];
};

const LaytimeInfo = ({
	selectedCargo,
}: Props) => {
	const content = useMemo(() => {
		if (!selectedCargo) {
			return null;
		}

		const {
			stats,
			currency,
			demurrage,
			despatch,
			demurrageLoading,
			demurrageDischarge,
			despatchLoading,
			despatchDischarge,
			timeAllowedInterval,
			demurrageDespatchInterval,
		} = selectedCargo;

		switch (selectedCargo.laytimeTerms) {
			case LaytimeTerms.AVERAGED:
				return (
					<AveragedStats
						stats={stats}
						interval={selectedCargo.CargoPorts[0].laytimeInterval}
						currency={currency}
						demurrageRateLoading={demurrageLoading}
						demurrageRateDischarging={demurrageDischarge}
						despatchRateLoading={despatchLoading}
						despatchRateDischarging={despatchDischarge}
						demurrageDespatchInterval={demurrageDespatchInterval}
						demurrageTerm={selectedCargo.demurrageTerm}
					/>
				);

			case LaytimeTerms.REVERSIBLE:
				return (
					<ReversibleStats
						stats={stats}
						currency={currency}
						demurrageRate={demurrage}
						despatchRate={despatch}
						interval={timeAllowedInterval}
						demurrageDespatchInterval={demurrageDespatchInterval}
						demurrageTerm={selectedCargo.demurrageTerm}
					/>
				);

			default:
			case LaytimeTerms.NON_REVERSIBLE:
				return (
					<NonReversibleStats
						stats={stats}
						currency={currency}
						demurrageTerm={selectedCargo.demurrageTerm}
					/>
				);
		}
	}, [selectedCargo]);

	if (!selectedCargo) {
		return (<Empty />);
	}

	return (
		<Col span={24}>
			{content}
		</Col>
	);
};

export default LaytimeInfo;
